import React from 'react';
import PropTypes from 'prop-types';

import Page from './Page';
import Property from './Property';
import FacetValues from './FacetValues';
import FacetImages from './FacetImages';
import Translation from './Translation';

function Cover({facets, content, startPageNumber, maxPageNumber}) {
	const {mainImage, sxnumbers, productname, leuchtmittel, lichtfarbe, certificates} = content;
	return (
		<Page
			content={content}
			number={startPageNumber}
			maxPageNumber={maxPageNumber}
		>
			<h1 className="slx-mounting-cover__title">
				{productname ? <span dangerouslySetInnerHTML={{__html: productname}} /> : <FacetValues facet={facets[4]} value="label" />}
				</h1>
			<h2 className="slx-mounting-cover__sub-title"><Translation name="mounting-instruction" /></h2>

			{mainImage &&
				<img
					key="image"
					className="slx-mounting-cover__image"
					src={mainImage} />
			}

			<dl className="slx-mounting-cover__details">
				<h2 className="slx-mounting-cover__details-title">
					<FacetValues facet={facets[42]} value="descriptionShort" />
				</h2>

				{sxnumbers &&
					<dd
						key="sxnumbers"
						className="slx-mounting-cover__details-sxnumbers"
						dangerouslySetInnerHTML={{__html: sxnumbers}}
						/>
				}

				<dd>
					{leuchtmittel ? <span dangerouslySetInnerHTML={{__html: leuchtmittel}} /> : <FacetValues facet={facets[8]} value="label" />}
					<br/>
					{lichtfarbe ? <span dangerouslySetInnerHTML={{__html: lichtfarbe}} /> : <FacetValues facet={facets[6]} value="label" />}
				</dd>

				<dd className="slx-mounting-cover__badges">
					{certificates ?
						certificates.split(',').map(image => (
							<img
								key={image.trim()}
								src={'//products.selux.com/products/assets/certification_icons/' + image.trim()}
								className="slx-mounting-facet-image"
							/>))
						:
						<span><FacetImages facet={facets[27]} /> <FacetImages facet={facets[28]} /> <FacetImages facet={facets[29]} /> <FacetImages facet={facets[30]} /> <FacetImages facet={facets[31]} /></span>
					}
				</dd>

			</dl>
		</Page>
	);
}

Cover.propTypes = {
	facets: PropTypes.object.isRequired,
	content: PropTypes.object.isRequired,
	startPageNumber: PropTypes.number.isRequired,
	maxPageNumber: PropTypes.number.isRequired,
};

export default React.memo(Cover);

export function numPages() {
	return 1;
}
